import { DashboardScreen } from './DashboardScreen';
import { WorkspaceGrowthEmpty } from './WorkspaceGrowthEmpty';
import { WorkspaceHero } from './WorkspaceHero';
import { WorkspaceSummaryRow } from './WorkspaceSummaryRow';

const PAGE = 'workspace_dashboard';

// A workspace's single screen — the merge of the old "Agents at work" / "Grow & Goals" tabs, with Goals
// itself since lifted to the top-level `/goals` screen. It leads with the summary tiles (Tasks · Goals ·
// Routines · Files · Apps), each scoped to this Space and each linking to its own screen pre-filtered to
// it, and continues into the Space's growth dashboard.
//
// Each workspace is its own dashboard (slug = the workspace slug), so the dashboard half renders
// through the shared DashboardScreen (GET /api/dashboard?dashboard=<slug>) — identical pipeline to the
// catch-up home. `workspace` names the owning dashboard (and scopes a widget's drill-in to this
// workspace so the back button returns here); no `page` → its bento.
export function WorkspaceDashboard({ slug }: { slug: string }) {
  // The same hero (badge + name + description) plus the summary row is pinned to the top of every branch
  // — the resolved dashboard + loader (via DashboardScreen's `header`) and the empty state
  // (WorkspaceGrowthEmpty renders its own).
  const header = (
    <>
      <WorkspaceHero slug={slug} page={PAGE} />
      <WorkspaceSummaryRow slug={slug} page={PAGE} />
    </>
  );
  return (
    <DashboardScreen
      workspace={slug}
      header={header}
      missing={<WorkspaceGrowthEmpty slug={slug} page={PAGE} />}
    />
  );
}
